import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export const CredentialsImageSection = () => {
  return <section className="py-20 bg-[#050505] relative overflow-hidden" data-id="element-2225">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(20,20,20,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(20,20,20,0.5)_1px,transparent_1px)] bg-[size:40px_40px] opacity-30 pointer-events-none" data-id="element-2226" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-2227">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-2228">
          {/* Forensic Frame */}
          <div className="relative p-2 border border-[#FF0000]/30 bg-[#0a0a0a]" data-id="element-2229">
            {/* Corner Markers */}
            <div className="absolute -top-1 -left-1 w-6 h-6 border-t-2 border-l-2 border-[#FF0000] z-20" data-id="element-2230" />
            <div className="absolute -top-1 -right-1 w-6 h-6 border-t-2 border-r-2 border-[#FF0000] z-20" data-id="element-2231" />
            <div className="absolute -bottom-1 -left-1 w-6 h-6 border-b-2 border-l-2 border-[#FF0000] z-20" data-id="element-2232" />
            <div className="absolute -bottom-1 -right-1 w-6 h-6 border-b-2 border-r-2 border-[#FF0000] z-20" data-id="element-2233" />

            <div className="relative overflow-hidden rounded-lg" data-id="element-2234">
              <img src="https://cdn.magicpatterns.com/uploads/i2JSsJixS53rV1tiMBtmmS/Screenshot_20260115-201836_1.png" alt="ToxicDetector.ai bottle with scientific credentials - Developed with Harvard and Yale Scientists, Years of Development, 17 Prototypes Tested, Approved by Behavioral Expert" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-700" loading="lazy" decoding="async" data-id="element-2235" />

              {/* Scan Line Overlay */}
              <div className="absolute top-0 left-0 w-full h-[2px] bg-[#FF0000] shadow-[0_0_15px_#FF0000] animate-[scan_4s_ease-in-out_infinite] opacity-50" data-id="element-2236" />
            </div>
          </div>

          {/* Glow Effect */}
          <div className="absolute -inset-4 bg-[#FF0000]/5 blur-3xl -z-10 rounded-full" data-id="element-2237" />
        </motion.div>
      </div>
    </section>;
};